import * as React from 'react';
import type { ComboSelectorProps } from '~/Partials/ComboSelector/ComboSelector';
import { ComboSelector } from '~/Partials/ComboSelector/ComboSelector';

export interface SubjectsFilterProps
    extends Pick<ComboSelectorProps, 'name' | 'options' | 'onChange' | 'currentValue'> {
    label: string;
}

export const SubjectsFilter: React.FC<SubjectsFilterProps> = props => (
    <ComboSelector
        {...props}
        variant="button"
        selectSwitchCallback={size => size > 4}
        colorVariant="greySelectDarkButtons"
    />
);
